import React from 'react';
import { PartnerClinicsSection } from '../components/PartnerClinicsSection';
import { SuccessRateSection } from '../components/SuccessRateSection';
export function Clinics() {
  return <div data-id="element-868">
      <PartnerClinicsSection data-id="element-869" />
      <SuccessRateSection data-id="element-870" />
    </div>;
}